import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getSessionId = () => {
  let sid = sessionStorage.getItem('analytics_sid');
  if (!sid) {
    sid = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem('analytics_sid', sid);
  }
  return sid;
};

/**
 * Tracks a page view on mount. Only fires once per (path + page_name) per render.
 */
export const useTrackPageView = ({ path, pageName, hotel } = {}) => {
  useEffect(() => {
    const send = async () => {
      try {
        await axios.post(`${API}/analytics/track`, {
          path: path || window.location.pathname,
          page_name: pageName || document.title || '',
          hotel: hotel || '',
          referrer: document.referrer || '',
          session_id: getSessionId(),
        });
      } catch (_) {
        // Silently fail - analytics shouldn't break the app
      }
    };
    send();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, pageName, hotel]);
};

/**
 * Returns a function to track a custom event (form submit, click, etc.)
 */
export const trackEvent = async ({ eventType, page, hotel, label } = {}) => {
  try {
    await axios.post(`${API}/analytics/event`, {
      event_type: eventType,
      page: page || window.location.pathname,
      hotel: hotel || '',
      label: label || '',
      session_id: getSessionId(),
    });
  } catch (_) {
    // Silently fail
  }
};
